import i18n from '@plugins/vue-i18n'

export default function(store) {
  store.$i18n = i18n
}
